<template>
  <v-card flat>
    <v-card-text class="my-12">
      <v-img class="mx-auto" :src="$images.SURVEY_COMPLETE" width="150"></v-img>
      <v-card-title class="d-block text-center">
        Thank you for your feedback!
      </v-card-title>
      <v-card-subtitle class="px-16 text-center">
        That's the end of the survey. Thanks for taking the time to share your
        feedback with us. We promise to keep your identity anonymous!
      </v-card-subtitle>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SurveyComplete",
  components: {},
  props: {},
  computed: {
    ...mapGetters({})
  },
  created() {},
  methods: {}
};
</script>
